module.exports = __webpack_public_path__ + "img/recovery.ecfea2d9.svg";